import { render, staticRenderFns } from "./AreasNavItem.vue?vue&type=template&id=1af3cd36&"
import script from "./AreasNavItem.vue?vue&type=script&lang=js&"
export * from "./AreasNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports